import React, { useEffect, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import zhTwLocale from '@fullcalendar/core/locales/zh-tw';

import '../../../css/components/Schedule/Calendar/Calendar.css';

import { extendedProps as EP_FIELDS, OrderInfoCardList } from '../../../constants';

import { GenericModal } from '../../../components';
import { OrderId } from '../../../utils';

const Calendar = ({ data }) => {
  useEffect(() => {
    if (data) {
      setOrdersData(data);
    }
  }, [data]);
  const calendarRef = useRef(null);
  const [ordersData, setOrdersData] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null); // 存放點擊事件
  const [isModalOpen, setIsModalOpen] = useState(false);
  const events = ordersData.map(order => {
    const extendedProps = {};
    EP_FIELDS.forEach(field => {
      if (field === 'address') {
        extendedProps[field] = `${order.addressCity}${order.addressDistrict}${order.addressDetailed}`;
      } else {
        extendedProps[field] = order[field];
      }
    });

    return {
      id: OrderId(order.id),
      title: `${order.name} - ${order.status === 1 ? "已通過" : order.status === 2 ? "未通過" : "未審核"}`,
      deliveryDate: order.deliveryDate.slice(0, 10),
      start: order.deliveryDate,
      ...extendedProps,
      color: order.status ? order.status === 2 ? "#3e59f5" : "#0dcaf0" : "#dc3545"
    };
  });

  return (
    <div className="container-fluid">
      <h1 className="h3 mb-4 mt-4 text-gray-800 text-primary">訂單日曆</h1>

      <div className="card shadow mb-4">
        <div className="card-header py-3 d-flex align-items-center">
          <h6 className="m-0 fw-bold text-primary">
            <i className="fas fa-calendar-alt me-2"></i>
            查看審核狀態送貨日期
          </h6>
        </div>

        <div className="card-body">
          <div className="CalendarLayout">
            <FullCalendar
              key={JSON.stringify(ordersData)}
              ref={calendarRef}
              plugins={[dayGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              locale={zhTwLocale}
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,dayGridWeek,dayGridDay'
              }}
              height="auto"
              dayMaxEvents={5}
              events={events}
              eventClick={info => {
                console.log({ ...info.event._def, ...info.event.extendedProps })
                setSelectedEvent({ ...info.event._def, ...info.event.extendedProps });
                setIsModalOpen(true);
              }}
            />
          </div>
        </div>
      </div>

      {selectedEvent && (
        <GenericModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          children={
            <div className="card order-info-card">
              {
                OrderInfoCardList.map(item => {
                  if (item.field === 'isShipped') {

                    return <div className="mb-2">
                      <strong>{item.name}</strong>
                      <span className={`status ${selectedEvent[item.field] ? 'shipped' : 'pending'}`}>
                        {selectedEvent[item.field] ? "已送達" : "未送達"}
                      </span>
                    </div>
                  } else if (item.field === 'status') {
                    return <div className="mb-2">
                      <strong>{item.name}</strong>
                      <span className={`status ${selectedEvent[item.field] ? selectedEvent[item.field] === 1 ? 'approved' : 'unReviewed' : 'rejected'}`}>
                        {selectedEvent[item.field] === 1 ? "已通過" : selectedEvent[item.field] === 2 ? "未通過" : "未審核"}
                      </span>
                    </div>
                  } else if (item.field === 'title') {
                    return <h5>{selectedEvent[item.field]}</h5>
                  } else {
                    return <div className="mb-2"><strong>{item.name}</strong> <span>{selectedEvent[item.field]}</span></div>
                  }
                })
              }
            </div>
          }
        />

      )}
    </div>
  );
};

export { Calendar };
